(function($) {

  function render_map( $el ) {

    // var
    var $markers = $el.find('.marker');

    // Custom zoom level set? 
    if ( $('.acf-map-zoom').length ) {
      var $zoomSet = $('.acf-map-zoom');
      var $zoom = parseInt($zoomSet.val());
    }
    else {
      var $zoom = 10;
    }

    // vars
    var args = {
      zoom : $zoom,
      mapTypeId : google.maps.MapTypeId.ROADMAP,
      mapTypeControl: false,
      scrollwheel: false,
      draggable: true,
    };

    // create map
    var map = new google.maps.Map( $el[0], args);

    // add a markers reference
    map.markers = [];

    // add markers
    $markers.each(function(){
      add_marker( $(this), map );
    });

    // center map
    center_map( map );
  }

  function add_marker( $marker, map ) {

    // var
    var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

    // create marker
    // var icon = WPURLS.theme_url + '/images/marker.png';

    var marker = new google.maps.Marker({
      position  : latlng,
      // icon : icon,
      map : map
    });

    // add to array
    map.markers.push( marker );

    // if marker contains HTML, add it to an infoWindow
    if ( $marker.html() )
    {
      // create info window
      var infowindow = new google.maps.InfoWindow({
        content   : $marker.html()
      });

      // show info window when marker is clicked
      google.maps.event.addListener(marker, 'click', function() {
        infowindow.open( map, marker );
      });
    }
  }

  function center_map( map ) {

    var bounds = new google.maps.LatLngBounds();

    // loop through all markers and create bounds
    $.each( map.markers, function( i, marker ){

      var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );

      bounds.extend( latlng );
    });

    // Only 1 marker?
    if ( map.markers.length == 1 )
    {
      map.setCenter( bounds.getCenter() );
    }
    else
    {
      map.fitBounds( bounds );
    }
  }

  $(document).ready(function(){

    $('.acf-map').each(function(){

      var $this = $(this);

      if (! $this.parent('#tab-3') ) {
        render_map( $this );
      }
    });

    var tab_rendered = false;
    $('.tab-link.tab-2').on('click', function(){

      if ( ! tab_rendered ) {
        render_map( $('#tab-2 .acf-map') );
        tab_rendered = true;
      }
    });
  });

})(jQuery);